import { TOfferCategory } from '@cian/chats-api';

import { mapMessage } from './mapMessage';
import { IOffer } from '../repositories/chats/entities/offer/Offer';
import { IOffer1 } from '../repositories/chats/entities/offer/Offer1';
import { ISyncChat } from '../repositories/chats/entities/synchronization/SyncChat';
import { ISyncChatV31 } from '../repositories/chats/entities/synchronization_v3/SyncChatV31';
import { IChat } from '../types/chatList';
import { TOffer } from '../types/offer';

export const mapChat = (chat: ISyncChat | ISyncChatV31): IChat => {
  const { datetimeForSorting, ...chatProps } = chat;

  const updated = new Date(datetimeForSorting).getTime();

  return {
    ...chatProps,
    updated,
    offer: chat.offer ? mapOffer(chat.offer) : undefined,
    lastMessage: chat.lastMessage ? mapMessage(chat.lastMessage) : undefined,
  };
};

function mapOffer(offer: IOffer | IOffer1): TOffer {
  return {
    ...offer,
    category: (offer.category || 'flatSale') as TOfferCategory,
    fullUrl: offer.fullUrl || '',
  };
}
